import { cn } from '@/lib/utils';

interface PageHeaderProps {
  /** Page title. A string is rendered with the canonical heading style; pass a
   *  ReactNode to fully control the markup. */
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Right-aligned actions (buttons, filters). */
  actions?: React.ReactNode;
  /** Render a string title in monospace — for document-number pages (PO#, picklist#). */
  mono?: boolean;
  className?: string;
}

// Canonical page header. Title style is fixed (text-2xl font-bold tracking-tight)
// so every page reads the same; `mono` keeps document-number titles monospace.
// Breadcrumbs are intentionally out of v1 (no deep-nav page needs them yet).
export function PageHeader({ title, description, actions, mono, className }: PageHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        {typeof title === 'string' ? (
          <h1 className={cn('text-2xl font-bold tracking-tight', mono && 'font-mono')}>
            {title}
          </h1>
        ) : (
          title
        )}
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
